module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAATCAYAAACZZ43PAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADwSURBVHgBpVTRDYIwED0aE/jkH0hwA90AN3ADcQLcAJ2AOIGMwiYQIIEZSADvTPEDaCnwPpqml/fa93otwA7keX7VYAOKovAYY5++77PDGmJVVS6SiOjxJTWBNE1NXdfDruse49qiQF3XQdu2T9zVnKsLBbjPCMknkGAiMOMTlATIp2EYAfdpgiJ+AmVZ+pqmRUhWJv4FkBwj+QYbwWzb9tHvHecZbACjAUXipmnOaOEFKzFpZboFuncVW3jyRPgWhn7HqSsTYKKi4ziJZVnHpXyEAgMoHzzJBfN5z9VXPedxPtIMZOCNF9J/AHtAQX8BacaEbMMib1MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/Polygon_3.png
// module id = 3
// module chunks = 1